import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GroupResource } from '../domain/dtos/free-member'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetGroupResourceDetails {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(id: string): Promise<GroupResource> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.FUNCTIONS_URL}/groupResource/get/pt`,
      body: { data: { id } },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data.result
    }

    throw new GeneralError()
  }
}
